export const animateOnScroll = {
  mounted() {
    const elements = this.$el.querySelectorAll('.animate-block')
    if (!elements.length) return

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible')
          observer.unobserve(entry.target)
        }
      })
    }, { root: null, threshold: 0.12 })

    elements.forEach(el => observer.observe(el))
  }
}
